import CourseReport from "../Pages/CourseReport/CourseReport";
import CreateDummy from "../Pages/CreateDummy/CreateDummy";
import CompletedQues from "../Pages/CreatePaper/CompletedQues";
import CreatePaper from "../Pages/CreatePaper/CreatePaper";
import PaperMatrix from "../Pages/CreatePaper/PaperMatrix/PaperMatrix";
import MatrixQuestions from "../Pages/CreatePaper/PaperMatrix/Questions/MatrixQuestions";
import Dashboard from "../Pages/Dashboard/Dashboard";
import DeletePaper from "../Pages/DeletePaper/DeletePaper";
import Answered from "../Pages/Doubts/Answered/Answered";
import Doubts from "../Pages/Doubts/Doubts";
import Unanswered from "../Pages/Doubts/Unanswered/Unanswered";
import EditPaper from "../Pages/EditPaper/EditPaper";
import EditPaperInput from "../Pages/EditPaper/EditPaperInput/EditPaperInput";
import EditRequestPaper from "../Pages/EditRequestPaper/EditRequestPaper";
import EditSubTopic from "../Pages/EditSubTopic/EditSubTopic";
import EditTopic from "../Pages/EditTopic/EditTopic";
import FacultyPaperRemove from "../Pages/FacultyPaperRemove/FacultyPaperRemove";
import Myschedule from "../Pages/Myschedule/Myschedule";
import FormatEdit from "../Pages/PaperFormat/FormatEdit/FormatEdit";
import PaperFormat from "../Pages/PaperFormat/PaperFormat";
import ProfileData from "../Pages/ProfileList/ProfileData/ProfileData";
import ProfileList from "../Pages/ProfileList/ProfileList";
import PublishPaper from "../Pages/PublishPaper/PublishPaper";
import PublishPaperView from "../Pages/PublishPaper/PublishPaperView/PublishPaperView";
import ApproveQuestion from "../Pages/Questions/ApproveQuestion/ApproveQuestion";
import AddQuestion from "../Pages/Questions/EditQuestion/AddQuestion/AddQuestion";
import Edit from "../Pages/Questions/EditQuestion/Edit/Edit";
import EditQuestion from "../Pages/Questions/EditQuestion/EditQuestion";
import SearchQuestion from "../Pages/Questions/SearchQuestion/SearchQuestion";
import VerifyQuestion from "../Pages/Questions/VerifyQuestion/VerifyQuestion";
import RequestPaper from "../Pages/Request Paper/RequestPaper";
import Unauthorized from "../Pages/Unauthorized/Unauthorized";
import AddUser from "../Pages/UserList/AddUser/AddUser";
import UpdateUser from "../Pages/UserList/UpdateUser/UpdateUser";
import UserList from "../Pages/UserList/UserList";
import BulkPaperRequest from "../Pages/BulkPaperRequest/BulkPaperRequest";
import BulkQuestionRequest from "../Pages/BulkQuestionRequest/BulkQuestionRequest";
import TopicwiseQuestionRender from "../Pages/BulkQuestionRequest/TopicwiseQuestionRender/TopicwiseQuestionRender";
import AnswerKey from "../Pages/PublishPaper/AnswerKey/AnswerKey";
import Solution from "../Pages/PublishPaper/Solution/Solution";
import GeneratePaper from "../Pages/PublishPaper/GeneratePaper/GeneratePaper";
import { Homework } from "../Pages/Myschedule/Homework";
import { HomeworkPreview } from "../Pages/Myschedule/HomeworkPreview";
import { HomeworkDetails } from "../Pages/HomeworkDetails/HomeworkDetails";
// import { ViewQuestions } from "../Pages/HomeworkDetails/ViewQuestions";
import { HomeworkList } from "../Pages/HomeworkDetails/HomeworkList";
import { StudentDetails } from "../Pages/HomeworkDetails/StudentDetails";
import { QuestionList } from "../Pages/QuestionsList/QuestionList"
import { ExerciseDPP } from "../Pages/ExerciseDpp Upload/ExerciseDpp";
import FacultyErrorReport from "../Pages/FacultyErrorReport/FacultyErrorReport";
// import AnswerKeyBoard from "../Pages/PublishPaper/AnswerKeyBoard/AnswerKeyBoard";
import QuestionModuleRender from "../Pages/BulkQuestionRequest/QuestionModuleRender";
import SampleQuestionModuleRender from "../Pages/BulkQuestionRequest/SampleQuestionModuleRender";
import QuestionSolutionRender from "../Pages/BulkQuestionRequest/QuestionSolutionRender";
import CopyRequest from "../Pages/CopyRequest/CopyRequest";
import OTPList from "../Pages/OTPList/OTPList";
import QuestionIngestion from "../Pages/Question Ingestion/QuestionIngestion";
import ViewQuestions from "../Pages/Question Ingestion/ViewQuestions";
import { QuestionListOptions } from "../Pages/QuestionListOption/QuestionList";
import PdfReader from "../Pages/PdfReader/Pdfproofreader";
import StudentAttendance from "../Pages/StudentAttendance/StudentAttendance";
import FacultyPaperCorrection from "../Pages/FacultyPaperCorrection/facultyPaperCorrection";
import PaperCorrectionList from "../Pages/FacultyPaperCorrectionList/PaperCorrectionList";


export const RouteList = [
  {
    path: "unauthorized",
    element: <Unauthorized />,
    role: null,
    child: [],
    showMenu: true,
  },
  {
    path: "/dashboard",
    element: <Dashboard />,
    role: null,
    child: [],
    showMenu: true,
  },
  {
    path: "topicwiseQuestionHtml",
    element: <TopicwiseQuestionRender />,
    role: null,
    child: [],
    showMenu: false,
  },
  {
    path: "questionmodule",
    element: <QuestionModuleRender />,
    role: null,
    child: [],
    showMenu: false,
  },
  {
    path: "samplequestion",
    element: <SampleQuestionModuleRender />,
    role: null,
    child: [],
    showMenu: false,
  },
  {
    path: "module_question_solution",
    element: <QuestionSolutionRender />,
    role: null,
    child: [],
    showMenu: false,
  },
  {
    path: "otplist",
    element: "",
    role: 53,
    showMenu: true,
    child: [
      {
        path: "",
        element: <OTPList />,
      },

    ],
  },
  {
    path: "createPaper",
    element: "",
    showMenu: true,
    role: 57,
    child: [
      {
        path: "",
        element: <CreatePaper />,
      },
      {
        path: "createDummy",
        element: <CreateDummy />,
      },
      {
        path: "CompletedQues",
        element: <CompletedQues />,
      },
      {
        path: "paperMatrix",
        element: <PaperMatrix />,
      },
      {
        path: "paperMatrix/Questions",
        element: <MatrixQuestions />,
      },
    ],
  },
  {
    path: "",
    element: "",
    showMenu: true,
    role: 56,
    child: [
      // {
      //   path: "verifyQuestion",
      //   element: <VerifyQuestion />,
      // },
      {
        path: "search-question",
        element: <SearchQuestion />,
      },
      // {
      //   path: "approveQuestion",
      //   element: <ApproveQuestion />,
      // },
    ],
  },
  {
    path: "editQuestion",
    element: "",
    role: 13,
    showMenu: true,
    child: [
      {
        path: "",
        element: <EditQuestion />,
      },
      {
        path: "edit/:qid",
        element: <Edit />,
      },
      {
        path: "addQuestion",
        element: <AddQuestion />,
      }
    ],
  },


  {
    path: "copyRequest",
    element: "",
    role: 50,
    showMenu: true,
    child: [
      {
        path: "",
        element: <CopyRequest />,
      },
      {
        path: "copy/:qid",
        element: <Edit />,
      },

    ],
  },
  {
    path: "bulkQuestionRequest",
    element: "",
    role: 13,
    showMenu: true,
    child: [
      {
        path: "",
        element: <BulkQuestionRequest />,
      },
    ],
  },
  {
    path: "paperFormat",
    element: "",
    role: 10,
    showMenu: true,
    child: [
      {
        path: "",
        element: <PaperFormat />,
      },
      {
        path: "edit/:formatid",
        element: <FormatEdit />,
      },
    ],
  },

  {
    path: "publishPaper",
    element: "",
    role: 15,
    showMenu: true,
    child: [
      {
        path: "",
        element: <PublishPaper />,
      },
      {
        path: "publishedView/:pid",
        element: <PublishPaperView />,
      },
    ],
  },
  {
    path: "",
    element: '',
    role: 15,
    showMenu: false,
    child: [
      {
        path: "paper",
        element: <GeneratePaper />,
      },
      {
        path: "answerkey",
        element: <AnswerKey />,
      },
      {
        path: "solution",
        element: <Solution />,
      },
    ],
  },
  {
    path: "requestPaper",
    element: "",
    role: 59,
    showMenu: true,
    child: [
      {
        path: "",
        element: <RequestPaper />,
      },
    ],
  },
  {
    path: "editTopic",
    element: "",
    showMenu: true,
    role: 37,
    child: [
      {
        path: "",
        element: <EditTopic />,
      },
    ],
  },
  {
    path: "editSubTopic",
    element: "",
    showMenu: true,
    role: 36,
    child: [
      {
        path: "",
        element: <EditSubTopic />,
      },
    ],
  },
  {
    path: "editPaper",
    element: "",
    role: 60,
    showMenu: true,
    child: [
      {
        path: "",
        element: <EditPaper />,
      },
      {
        path: ":pid",
        element: <EditRequestPaper />,
        // element: <EditPaperInput />,
      },
    ],
  },
  {
    path: "deletePaper",
    element: "",
    role: 61,
    showMenu: true,
    child: [
      {
        path: "",
        element: <DeletePaper />,
      },
    ],
  },
  {
    path: "facultyPaperRemove",
    element: "",
    role: 58,
    showMenu: true,
    child: [
      {
        path: "",
        element: <FacultyPaperRemove />,
      },
    ],
  },
  {
    path: "bulkPaperRequest",
    element: "",
    role: 41,
    showMenu: true,
    child: [
      {
        path: "",
        element: <BulkPaperRequest />,
      },
    ],
  },
  {
    path: "bulkQuestionRequest",
    element: "",
    role: 42,
    showMenu: true,
    child: [
      {
        path: "",
        element: <BulkQuestionRequest />,
      },
    ],
  },
  {
    path: "exerciseDpp",
    element: "",
    role: 62,
    showMenu: true,
    child: [
      {
        path: "",
        element: <ExerciseDPP />,
      },
    ],
  },
  {
    path: "courseReport",
    element: "",
    role: 43,
    showMenu: true,
    child: [
      {
        path: "",
        element: <CourseReport />,
      },
    ],
  },
  {
    path: "schedule",
    element: "",
    role: 44,
    showMenu: true,
    child: [
      {
        path: "",
        element: <Myschedule />,
      },
      {
        path: "homework",
        element: <Homework />,
      },
      {
        path: "homework/preview",
        element: <HomeworkPreview />,
      },

    ],
  },

  {
    path: "homeworkDetails",
    element: "",
    role: 43,
    showMenu: true,
    child: [
      {
        path: "",
        element: <HomeworkDetails />
      },
      {
        path: "viewQuestion",
        element: <HomeworkList />
      },
      {
        path: "viewQuestion/viewQuestions",
        element: <ViewQuestions />
      },
      {
        path: "studentDetails",
        element: <StudentDetails />
      },
    ],
  },

  {
    path: "question-list",
    element: "",
    role: 48,
    showMenu: true,
    child: [
      {
        path: "",
        element: <QuestionList />,
      },
    ],
  },
  {
    path: "userList",
    element: "",
    role: 4,
    showMenu: true,
    child: [
      {
        path: "",
        element: <UserList />,
      },
      {
        path: "addUser",
        element: <AddUser />,
      },
      {
        path: "edit",
        element: <UpdateUser />,
      },
    ],
  },
  {
    path: "profileList",
    element: "",
    showMenu: true,
    role: 24,
    child: [
      {
        path: "",
        element: <ProfileList />,
      },
      {
        path: "rights",
        element: <ProfileData />,
      },
    ],
  },
  {
    path: "facultyError",
    element: "",
    role: 47,
    showMenu: true,
    child: [
      {
        path: "",
        element: <FacultyErrorReport />,
      },
    ],
  },
  {
    path: "search-question-list",
    element: "",
    role: 63,
    showMenu: true,
    child: [
      {
        path: "",
        element: <QuestionListOptions />,
      },
    ],
  },
  {
    path: "questionIngestion",
    element: "",
    role: 55,
    showMenu: true,
    child: [
      {
        path: "",
        element: <QuestionIngestion />,
      },
      {
        path: "viewQuestions/:uploadId",
        element: <ViewQuestions />,
      },
    ],
  },
  {
    path: "attendance",
    element: "",
    role: 0,
    showMenu: true,
    child: [
      {
        path: "",
        element: <StudentAttendance />,
      },
    ],
  },

  {
    path: "facultyPaperCorrection",
    element: "",
    role: 0,
    showMenu: true,
    child: [
      {
        path: "",
        element: <FacultyPaperCorrection />,
      },
    ],
  },
  {
    path: "papercorrectionList",
    element: "",
    role: 0,
    showMenu: true,
    child: [
      {
        path: "",
        element: <PaperCorrectionList />,
      },
    ],
  },
];
